import React from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Box } from '@mui/material';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import GuestInfoModal from '@/components/pages/GuestInfo/components/GuestInfoModal';
import './GuestInfoView.scss';

const GuestInfoView = props => {
  const {
    initialValues,
    onSubmit,
    loading,
    onBack,
    languageData,
    selectedCountry,
    showDropdown,
    dropdownRef,
    countries,
    handleCountrySelect,
    toggleDropdown,
    showModal,
    closeModal,
    userEmail,
  } = props;

  const SearchBar = props => {
    const { languageData, onBack } = props;
    return (
      <FlexContainer className={'SearchBar align-items-end'}>
        <i className="fa fa-chevron-left"></i>
        <Label className={'fontWhite text-12 margl10'} onClick={onBack}>
          {languageData === 'EN'
            ? 'Back to booking detail'
            : 'Volver al detalle de la reserva'}
        </Label>
      </FlexContainer>
    );
  };

  const GuestInfoLink = props => {
    const { languageData } = props;
    return (
      <FlexContainer className={'justify-between margt50 padlr80 margb80'}>
        <FlexContainer className={'flex-column'}>
          <Label
            className={'text-12'}
            style={{ color: 'rgba(255,255,255,0.4)' }}
          >
            {languageData === 'EN'
              ? 'Been here before?'
              : '¿Has estado aquí antes?'}
          </Label>
        </FlexContainer>
        <Label
          className={'text-12 pointer underline'}
          style={{
            transition: 'all 0.2s ease',
          }}
          onClick={() => {
            console.log('Redirect to Sign In');
          }}
          onMouseEnter={e => {
            e.target.style.opacity = '0.8';
            e.target.style.textDecoration = 'underline';
          }}
          onMouseLeave={e => {
            e.target.style.opacity = '1';
            e.target.style.textDecoration = 'underline';
          }}
        >
          {languageData === 'EN' ? 'Sign In' : 'Iniciar Sesión'}
        </Label>
      </FlexContainer>
    );
  };

  const GuestInfoTerms = props => {
    const { languageData } = props;
    return (
      <FlexContainer className="flex-column align-items-center justify-center text-center margt10 padlr30 row-gap-1">
        <Label
          className="text-12 text-center width100"
          style={{ color: 'rgba(255,255,255,0.4)' }}
        >
          {languageData === 'EN' ? (
            <React.Fragment>
              By selecting{' '}
              <strong>
                <span className="fontWhite">Sign up and Continue</span>
              </strong>
              , I agree to
            </React.Fragment>
          ) : (
            <React.Fragment>
              Al seleccionar{' '}
              <span className="fontWhite">Regístrate y continúa</span>, acepto
              los
            </React.Fragment>
          )}
        </Label>

        <Label
          className="text-12 text-center width100"
          style={{ color: 'rgba(255,255,255,0.4)' }}
        >
          {languageData === 'EN'
            ? 'Poppest Terms of Service, Privacy Policy, and'
            : 'Términos de Servicio, Política de Privacidad y'}
        </Label>

        <Label
          className="text-12 text-center width100"
          style={{ color: 'rgba(255,255,255,0.4)' }}
        >
          {languageData === 'EN'
            ? 'Promotional Terms'
            : 'Términos Promocionales de Poppest'}
        </Label>
      </FlexContainer>
    );
  };

  const GuestInfoFlagsNumber = props => {
    const {
      languageData,
      selectedCountry,
      showDropdown,
      countries,
      handleCountrySelect,
      toggleDropdown,
    } = props;
    return (
      <FlexContainer className="align-items-center justify-between width100">
        <FlexContainer
          className="align-items-center grayShadowBottom border-rad8px padtb12 padlr8 margr10 pointer pos-rel noShrink"
          style={{
            backgroundColor: 'rgba(255,255,255,0.1)',
            border: '2px solid rgba(255,255,255,0.3)',
            transition: 'all 0.2s ease',
          }}
          onClick={toggleDropdown}
          onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.2)';
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)';
          }}
        >
          <img
            src={selectedCountry.flag}
            alt={selectedCountry.name}
            className="width-30px height-20px margr8 border-rad8px borderrad2 objectCover"
          />

          <Label className="text-14 fontWhite">{selectedCountry.code}</Label>

          {showDropdown && (
            <FlexContainer
              className="flex-column pos-abs left0 border-rad8px margt5 pad8 top100 overflowY"
              style={{
                backgroundColor: 'rgba(0,0,0,0.95)',
                border: '1px solid rgba(255,255,255,0.3)',
                minWidth: '160px',
                zIndex: 1000,
                maxHeight: '200px',
              }}
            >
              {countries.map(country => (
                <FlexContainer
                  key={country.code}
                  className="align-items-center padv8 padh12 pointer"
                  style={{
                    backgroundColor:
                      selectedCountry.code === country.code
                        ? 'rgba(255,255,255,0.15)'
                        : 'transparent',
                    transition: 'all 0.2s ease',
                  }}
                  onClick={e => {
                    e.stopPropagation();
                    handleCountrySelect(country);
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.backgroundColor =
                      'rgba(255,255,255,0.1)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.backgroundColor =
                      selectedCountry.code === country.code
                        ? 'rgba(255,255,255,0.15)'
                        : 'transparent';
                  }}
                >
                  <img
                    src={country.flag}
                    alt={country.name}
                    className="width-20px height-15px margr10 borderrad2 objectCover"
                  />
                  <FlexContainer className="flex-column">
                    <Label className="text-12 fontWhite">{country.name}</Label>
                    <Label className="text-12 opacity-70">{country.code}</Label>
                  </FlexContainer>
                </FlexContainer>
              ))}
            </FlexContainer>
          )}
        </FlexContainer>

        <FlexContainer
          className="align-items-center grayShadowBottom border-rad12px padtb14 padlr16 boxSizing_borderBox flex-1"
          style={{
            backgroundColor: 'rgba(255,255,255,0)',
            border: '2px solid rgba(255,255,255,0.4)',
            transition: 'all 0.2s ease',
            minWidth: 0,
          }}
          onFocus={e => {
            e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.12)';
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.6)';
          }}
          onBlur={e => {
            e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0)';
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)';
          }}
        >
          <Field
            type="tel"
            name="phone"
            placeholder={
              languageData === 'EN' ? 'Mobile Number' : 'Teléfono móvil'
            }
            className="placeholder-custom bgTransparent borderNone width100 text-15 text-left flex-1 pad0 outlineNone fontWhite textTransformNone"
            style={{
              fontWeight: 500,
              minWidth: 0,
            }}
            onFocus={e => {
              e.target.parentElement.style.backgroundColor =
                'rgba(255,255,255,0.12)';
              e.target.parentElement.style.borderColor =
                'rgba(255,255,255,0.6)';
            }}
            onBlur={e => {
              e.target.parentElement.style.backgroundColor =
                'rgba(255,255,255,0)';
              e.target.parentElement.style.borderColor =
                'rgba(255,255,255,0.4)';
            }}
          />
        </FlexContainer>
      </FlexContainer>
    );
  };

  return (
    <>
      <FlexContainer
        className="GuestInfoView flex-column padlr10 justify-start items-center bgGradientBlue fontWhite"
        style={{
          filter: showModal ? 'blur(5px)' : 'none',
          transition: 'filter 0.3s ease',
          minHeight: '100vh',
        }}
      >
        <SearchBar languageData={languageData} onBack={onBack} />

        <FlexContainer className={'flex-column padlr10 margb30'}>
          <Label className={'text-26 margt20'}>
            {languageData === 'EN' ? 'Guest Info' : 'Información del Usuario'}
          </Label>

          <FlexContainer className={'flex-column align-items-center'}>
            <Formik initialValues={initialValues} onSubmit={onSubmit}>
              {({ isSubmitting }) => (
                <Form className="align-items-center format50 m-format100">
                  <Box mb={1}>
                    <Field
                      type="text"
                      name="name"
                      placeholder={
                        languageData === 'EN'
                          ? 'First and Last Name'
                          : 'Nombre y Apellido'
                      }
                      className={
                        'border-rad8px grayShadowBottom margt16 placeholder-custom width100 pad14 fontWhite text-15 boxSizing_borderBox outlineNone'
                      }
                      style={{
                        backgroundColor: 'rgba(255,255,255,0)',
                        border: '2px solid rgba(255,255,255,0.4)',
                        transition: 'all 0.2s ease',
                      }}
                      onBlur={e => {
                        e.target.style.backgroundColor =
                          'rgba(255,255,255,0.12)';
                        e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                        e.target.style.boxShadow =
                          '0 2px 4px rgba(0, 0, 0, 0.1)';
                      }}
                    />
                  </Box>

                  <Box mb={1} position="relative">
                    <Field
                      type="email"
                      name="email"
                      placeholder={
                        languageData === 'EN'
                          ? 'Email Address'
                          : 'Correo electrónico'
                      }
                      className={
                        'border-rad8px grayShadowBottom  placeholder-custom width100 pad14 fontWhite text-15 boxSizing_borderBox outlineNone'
                      }
                      style={{
                        backgroundColor: 'rgba(255,255,255,0)',
                        border: '2px solid rgba(255,255,255,0.4)',
                        transition: 'all 0.2s ease',
                      }}
                      onBlur={e => {
                        e.target.style.backgroundColor =
                          'rgba(255,255,255,0.12)';
                        e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                        e.target.style.boxShadow =
                          '0 2px 4px rgba(0, 0, 0, 0.1)';
                      }}
                    />
                  </Box>

                  <Box mb={1} ref={dropdownRef}>
                    <GuestInfoFlagsNumber
                      languageData={languageData}
                      selectedCountry={selectedCountry}
                      showDropdown={showDropdown}
                      countries={countries}
                      handleCountrySelect={handleCountrySelect}
                      toggleDropdown={toggleDropdown}
                    />
                  </Box>

                  <Button
                    className={'bgGradientSignUpPurple '}
                    type="submit"
                    fullWidth
                    style={{
                      mt: '5px',
                      py: 0.8,
                      color: 'white',
                      borderRadius: '10px',
                      textTransform: 'none',
                      transition: 'all 0.2s ease',
                      fontSize: '16px',

                      '&:hover': {
                        boxShadow: '0 6px 16px rgba(248, 87, 166, 0.5)',
                        transform: 'translateY(-1px)',
                      },
                      '&:disabled': {
                        opacity: 0.7,
                      },
                    }}
                    disabled={loading || isSubmitting}
                  >
                    {loading
                      ? languageData === 'EN'
                        ? 'Loading...'
                        : 'Cargando...'
                      : languageData === 'EN'
                        ? 'Sign up and Continue'
                        : 'Regístrate y continúa'}
                  </Button>

                  <GuestInfoTerms languageData={languageData} />
                  <GuestInfoLink languageData={languageData} />
                </Form>
              )}
            </Formik>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      <GuestInfoModal
        isOpen={showModal}
        onClose={closeModal}
        languageData={languageData}
        userEmail={userEmail}
      />
    </>
  );
};

export default GuestInfoView;
